module.exports = __webpack_public_path__ + "static/media/Graphical_abstract-NTPDase3.b58161c6.jpg";